import { api } from '../libs/api';

export default {
  /**
   * Gets/Puts/Patches/ a specific issue.
   *
   * @param {String} requestType - request type
   * @param {String} query - property type and its query
   * @param {String} id - issue id
   * @param {Object} data - data to patch
   * @param {Object} rawBody - raw body to send
   */
  propertyManagementAPI: async (
    { requestType = 'GET', query = '', id = null, data = undefined, rawBody = false } = {},
  ) => {
    return api({
      method: requestType,
      endpoint: `/property_management/${query}${id ? `/${id}/` : ''}`,
      usingAuthToken: true,
      data,
      rawBody,
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        // Validation errors
        if (error.status === 400) {
          return Promise.reject({ validationErrors: error.body });
        }
        throw error;
      });
  },

  /**
   * Gets/Puts/Patches/ a specific issue.
   *
   * @param {String} requestType - request type
   * @param {String} query - query type
   * @param {Object} data - data to patch
   * @param {Object} rawBody - raw body to send
   */
  tariffManagementAPI: async (
    { requestType = 'GET', query = '', id = null, data = undefined, rawBody = false } = {},
  ) => {
    return api({
      method: requestType,
      endpoint: `/tariff_management/${query}${id ? `/${id}/` : ''}`,
      usingAuthToken: true,
      data,
      rawBody,
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        // Validation errors
        if (error.status === 400) {
          return Promise.reject({ validationErrors: error.body });
        }
        throw error;
      });
  },

  /**
   * Gets/Puts/Patches/ resources under billing
   *
   * @param {String} requestType - request type
   * @param {String} query - query type
   * @param {String} id - item id
   * @param {Object} data - data to patch
   * @param {Object} rawBody - raw body to send
   */
  billingAPI: async (
    { requestType = 'GET', query = '', id = null, data = undefined, rawBody = false } = {},
  ) => {
    return api({
      method: requestType,
      endpoint: `/billing/${query}${id ? `/${id}/` : ''}`,
      usingAuthToken: true,
      data,
      rawBody,
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        // Validation errors
        if (error.status === 400) {
          return Promise.reject({ validationErrors: error.body });
        }
        throw error;
      });
  },

  /**
   * Checks if objects are locked.
   *
   * @param {String} requestType - request type
   * @param {String} query - query type
   * @param {String} id - item id
   */
  objectLocking: async ({ requestType = 'GET', query = '', id = null } = {}) => {
    return api({
      method: requestType,
      endpoint: `/object_locking/${query}${id ? `/${id}/` : ''}`,
      usingAuthToken: true,
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        // Validation errors
        if (error.status === 400) {
          return Promise.reject({ validationErrors: error.body });
        }
        throw error;
      });
  },

  /**
   * Builds the query params.
   */
  _buildQueryParams: params => {
    return Object.keys(params)
      .map(prop => params[prop] && `${prop}=${params[prop]}`)
      .filter(prop => !!prop)
      .join('&');
  },
};



// WEBPACK FOOTER //
// ./src/utils/api.js